//
// App JS
// -------------------

import { Player } from './js/player.js'

new Player(document.querySelector('.player'))
